import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'
import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { I18nContext } from '@elo-kit/components/i18n/i18n'

import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'

import './editable_image.scss'

const propTypes = {
  imageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loadingImage: PropTypes.bool,
  imageType: PropTypes.oneOf(['banner', 'round', 'default', 'logo', 'square', 'rectangular']),
  inForm: PropTypes.bool,
}

const defaultProps = {
  imageType: 'default',
  inForm: false,
}

class EditableImage extends Component {
  static contextType = I18nContext

  render() {
    const {
      onImageEdit,
      loadingImage,
      imageUrl,
      imageType,
      inForm,
      onImageDelete,
      uploadFiles,
      onUploadEdit,
      acceptedFiles,
      onFileDownload,
      description,
      label,
    } = this.props
    const I18n = this.context

    const isRectangular = imageType === 'rectangular'

    const editableBlockClasses = classNames('elo-editable-image', {
      'elo-editable-image--left': inForm,
      'elo-editable-image--between': description,
      'elo-editable-image--full-width': isRectangular,
    })

    const containerClasses = classNames(`elo-editable-image__${imageType}-container`, {
      'elo-editable-image__container--no-margin': inForm,
    })

    return (
      <div className={editableBlockClasses}>
        <div>
          {label && (
            <label className='field__label'>
              <span>{label}</span>
            </label>
          )}
          {loadingImage ? (
            <LoadingSpinner />
          ) : (
            <div className={containerClasses}>
              {imageUrl ? (
                <div className='elo-editable-image__download-button'>
                  {isRectangular ? (
                    <div
                      className={`elo-editable-image__${imageType}`}
                      style={{ backgroundImage: getBackgroundImageCss(imageUrl) }}
                    />
                  ) : (
                    <img className={`elo-editable-image__${imageType}`} src={imageUrl} alt={imageType} />
                  )}
                  {onFileDownload && (
                    <EloButton href={imageUrl} target='_blank' downloadOnClick>
                      <i className='fas fa-download' />
                      {I18n.t('react.shared.button.download_image')}
                    </EloButton>
                  )}
                </div>
              ) : (
                <i className={`fas fa-camera elo-editable-image__${imageType} elo-editable-image__no-image`} />
              )}
              {onImageEdit && (
                <button type='button' onClick={onImageEdit} className='elo-editable-image__edit-btn'>
                  {onUploadEdit && (
                    <label htmlFor='upload' className='elo-editable-image__upload-file'>
                      <input
                        id='upload'
                        name='upload'
                        type='file'
                        accept={acceptedFiles}
                        onChange={({ target }) => uploadFiles(target.files)}
                        style={{ display: 'none' }}
                      />
                    </label>
                  )}
                  <i className='fas fa-pencil-alt elo-editable-image__edit-icon' />
                </button>
              )}
              {onImageDelete && (
                <button type='button' onClick={onImageDelete} className='elo-editable-image__delete-btn'>
                  <i className='far fa-trash-alt' />
                </button>
              )}
            </div>
          )}
        </div>
        {description && <div className='elo-editable-image__description'>{description}</div>}
      </div>
    )
  }
}

EditableImage.displayName = 'EditableImage'
EditableImage.defaultProps = defaultProps
EditableImage.propTypes = propTypes

export default EditableImage
